import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { IconButton } from "@material-ui/core";
import { MdArrowBack } from "react-icons/md";
import { navigate } from "@reach/router";
import { BsFillPeopleFill } from "react-icons/bs";

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  appbar: {
    padding: theme.spacing(1, 0),
  },
}));

export default function TitleBar({ title, navigateTo, colorPrimary, followIcon }) {
  const classes = useStyles();

  return (
    <AppBar
      className={classes.appbar}
      position="sticky"
      color={colorPrimary ? "primary" : "inherit"}
    >
      <Toolbar>
        {navigateTo && (
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => {
              navigate(navigateTo);
            }}
          >
            <MdArrowBack />
          </IconButton>
        )}
        <Typography variant="h5" className={classes.title}>
          {title}
        </Typography>
        {followIcon && (
          <BsFillPeopleFill
            size={20}
            onClick={() => navigate("/follow")}
            style={{ cursor: "pointer" }}
          />
        )}
      </Toolbar>
    </AppBar>
  );
}
